<div
    class="partners-section"
    *ngIf="partnersComponent$ | async as partnersComponent"
>
    <ul
        *ngIf="
            partnersComponent &&
            partnersComponent.items &&
            partnersComponent.items.length
        "
    >
        <li *ngFor="let partner of partnersComponent.items">
            <a href="{{ partner.url }}">
                <img src="{{ partner.image_url }}" />
            </a>
        </li>
    </ul>
</div>
<div class="copyright-holder">
    <ul>
        <li class="copyright">
            <span *ngIf="brandName$ | async as brandName">{{ brandName }}</span>
            © {{ currentYear }}.
            <span *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                {{
                    moduleCustomerTexts.rights_reserved
                        ? moduleCustomerTexts.rights_reserved
                        : 'All rights reserved'
                }}
            </span>
        </li>
        <li
            *ngIf="
                terms_and_conditions_url$ | async as terms_and_conditions_url
            "
        >
            <a [href]="terms_and_conditions_url" target="_blank">
                <serviceos-ng-link
                    size="small"
                    *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts"
                >
                    {{
                        moduleCustomerTexts.terms_and_conditions
                            ? moduleCustomerTexts.terms_and_conditions
                            : 'Terms and Conditions'
                    }}
                </serviceos-ng-link>
            </a>
        </li>
        <span>|</span>
        <li *ngIf="privacy_policy_url$ | async as privacy_policy_url">
            <a [href]="privacy_policy_url" target="_blank">
                <serviceos-ng-link
                    size="small"
                    *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts"
                >
                    {{
                        moduleCustomerTexts.privacy_policy
                            ? moduleCustomerTexts.privacy_policy
                            : 'Privacy Policy'
                    }}
                </serviceos-ng-link>
            </a>
        </li>
    </ul>

    <!-- NEW Automated By section -->
    <div
        class="automated-by footer"
        *ngIf="
            automatedByComponent$ | async as automatedByComponent;
            else defaultAutomatedBySection
        "
    >
        <div *ngIf="!automatedByComponent.disable">
            <span *ngIf="automatedByComponent.title">
                {{
                    automatedByComponent.title
                }}
            </span>
            <a *ngIf="automatedByComponent.logo_external_link; else imageOnly" [href]="automatedByComponent.logo_external_link" target="_blank">
                <img *ngIf="automatedByComponent.logo_url" [src]="automatedByComponent.logo_url" [width]="100" />
            </a>
            <ng-template #imageOnly>
                <img [src]="automatedByComponent.logo_url" [width]="100" />
            </ng-template>
        </div>
    </div>

    <!-- OLD Automated By section -->
    <ng-template #defaultAutomatedBySection>
        <div
            class="automated-by footer"
            *ngIf="automated_brand$ | async as automated_brand"
        >
            <span
                *ngIf="
                    applicationModuleTexts$ | async as applicationModuleTexts
                "
            >
                {{
                    applicationModuleTexts.automated_by
                        ? applicationModuleTexts.automated_by
                        : 'Automated by'
                }}
            </span>
            <a [href]="automated_brand?.automated_by_site_url" target="_blank">
                <img
                    [src]="automated_brand?.automated_by_logo_url"
                    [width]="100"
                />
            </a>
        </div>
    </ng-template>
</div>
